module.exports = __webpack_public_path__ + "img/map_europa_png.1f97e14f.png";